<template>
  <div>
    <b-card class="shadow-lg bg-white rounded">
      <!--begin::Signin https://my.shepa.com/login?mailconfirmed=1 -->
      <div class="login-form login-signin">
        <div class="text-center">
          <img width="50%" src="/media/logos/logo-letter-1.png" class="mb-5" />
          <h3 class="font-size-h1">ورود</h3>
        </div>

        <!--begin::Form-->
        <b-form class="form" @submit.stop.prevent="onSubmit">
          <b-alert :variant="(mailconfirmed == 0 ? 'danger':'success')" :show="mailconfirmed!=null">
            {{mailconfirmed==0?"تایید پست الکترونیکی موفقیت آمیز نبود":"پست الکترونیکی با موفقیت تایید شد"}}
          </b-alert>
          <div
            role="alert"
            :show="mailconfirmed != null"
            :class="(mailconfirmed == 0 ? 'alert fade alert-danger':'alert fade alert-success')"
          >
            <div class="alert-text">
              پست الکترونیکی شما تایید شد
            </div>
          </div>
          <div
            role="alert"
            v-bind:class="{ show: errors.length }"
            class="alert fade alert-danger"
          >
            <div class="alert-text" v-for="(error, i) in errors" :key="i">
              {{ error }}
            </div>
          </div>

          <b-form-group
            label-class=""
            id="example-input-group-1"
            label="تلفن همراه"
            label-for="example-input-1"
          >
           <b-form-input
              id="example-input-1"
              name="example-input-1"
              placeholder="09123456789"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
            ></b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback"
              >تلفن همراه را به صورت صحیح وارد کنید</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            label-class=""
            id="example-input-group-2"
            label="رمز عبور"
            label-for="example-input-2"
          >
            <b-form-input
              type="password"
              id="example-input-2"
              name="example-input-2"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
            ></b-form-input>

            <b-form-invalid-feedback id="input-2-live-feedback"
              >رمز عبور اجباری است</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label="کد تایید">
            <b-row>
              <b-col cols="5">
                <b-form-input
                  v-model="form.captcha"
                  placeholder="کد تایید"
                ></b-form-input>
              </b-col>
              <b-col cols="5">
                <b-img
                  center
                  fluid
                  :src="captcha_img"
                  style="height: 38px"
                ></b-img>
              </b-col>
              <b-col>
                <b-button variant="warning" @click="resetCaptcha"
                  ><b-icon icon="arrow-clockwise"></b-icon
                ></b-button>
              </b-col>
            </b-row>
          </b-form-group>

          <!--begin::Action-->
          <div
            class="form-group d-flex flex-wrap justify-content-between align-items-center"
          >
            <button
              ref="kt_login_signin_submit"
              class="btn btn-warning btn-block font-weight-bold px-9 py-4 my-3 font-size-3"
            >
              ورود
            </button>
          </div>
          <!--end::Action-->
          <!--begin::Action-->
          <div
            class="form-group d-flex flex-wrap justify-content-between align-items-center"
          >
            <a
              href="/forget"
              class="text-hover-primary my-3 mr-2 font-weight-bold"
              id="kt_login_forgot"
              >بازیابی رمز عبور</a
            >
            <router-link
              class="font-weight-bold font-size-3 ml-2"
              :to="{ name: 'register' }"
              >ثبت نام</router-link
            >
          </div>
          <div
          >
            <p
              class="mr-2 font-weight-bold"
              id="kt_login_forgot"
              >نیاز به راهنمایی دارید؟ با شماره
              
              <a href="tel:+02191093000" class="text-hover-primary font-weight-bold">02191093000</a> تماس بگیرید</p
            >
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Form-->
      </div>
      <!--end::Signin-->
    </b-card>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-left: 3.5rem !important;
}
.shadow-lg {
  -webkit-box-shadow: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.3) !important;
  box-shadow: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.3) !important;
}
</style>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
const mustBeMobile = (value) =>value.startsWith("09") || value.startsWith("۰۹"); //!helpers.req(value) || value.indexOf('cool') >= 0
  
const mobile = (value, vm) => /^[\u06F0-\u06F9\s||z0-9]{11}$/.test(value);

import sessionHelper from "../../helpers/sessionHelper";
import httpHelper from "../../helpers/httpHelper";
import routesMap from '@/helpers/routesMap'
export default {
  mixins: [validationMixin],
  name: "login",
  components: {
    "vue-recaptcha": VueRecaptcha,
  },
  data() {
    return {
      // Remove this dummy login info
      form: {
        email: "",
        password: "",
        captcha: "",
      },
      captcha_img: "",
      randNum: "",
      errors: [],
      captcha_int: 0,
      mailconfirmed:null,
      routesMap,
    };
  },
  validations: {
    form: {
      email: {
        required,
        //mustBeMobile,
        mobile,
        minLength: minLength(11),
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onVerify: function (response) {
      if (response) {
        this.form.robot = true;
        this.form.captcha = response;
      }
    },
    resetCaptcha() {
      httpHelper.getData("cp").then((res) => {
        this.captcha_img = res.result.img;
        this.form.captcha = "";
        this.form.key = res.result.key;
      });
    },
    resetForm() {
      this.form = {
        email: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    // checkIsNumber(event) {
    //   var s = "0123456789";
    //   if (s.indexOf(event.key) < 0) {
    //     return event.preventDefault();
    //   }
    // },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model.toEnDigits();
      const password = this.$v.form.password.$model;
      this.errors = [];
      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      var data = {
        email: email,
        password: password,
        captcha: this.form.captcha.toEnDigits(),
        key: this.form.key,
      };
      httpHelper
        .postData("users/login", data)
        .then((res) => {
          if (res.success == false) {
            this.resetCaptcha();
            this.errors = [res.error];
          } else {
            sessionHelper.setUser(res.result);
            this.$router.push({ name: "dashboard" });
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
  },
  mounted() {
    this.mailconfirmed=this.$route.query!=null ? this.$route.query.mailconfirmed : null;
    sessionHelper.logout();
    //this.resetCaptcha();
    var self = this;
    self.resetCaptcha();
    this.captcha_int = setInterval(function () {
      self.resetCaptcha();
    }, 60000);
  },
  computed: {},
};
</script>
